const heroImg = "/hero-magicprint.webp";
const heroMobileImg = "/hero-magicprint-mobile.webp";
import { Button } from "@/components/ui/button";
import { ArrowRight, MessageCircle } from "@/components/Icon";
import { Link } from "react-router-dom";
import { trackEvent } from "@/lib/analytics";

const Hero = () => (
  <section id="home" className="relative min-h-[90vh] flex items-center overflow-hidden">
    <img
      src={heroImg}
      srcSet={`${heroMobileImg} 800w, ${heroImg} 1600w`}
      sizes="100vw"
      alt="Professionele textieldrukkerij"
      className="absolute inset-0 w-full h-full object-cover"
      width={1600}
      height={627}
      {...({ fetchpriority: "high" } as Record<string, string>)}
      decoding="async"
    />
    <div className="absolute inset-0" style={{ background: "var(--hero-overlay)" }} />

    <div className="container relative z-10 py-32 md:py-40">
      <div className="max-w-2xl space-y-6 animate-fade-up">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold tracking-wider uppercase bg-white text-[#0a2933] shadow-lg">
          <span className="w-2 h-2 rounded-full bg-primary" />
          Sinds 1994 — Den Haag
        </span>
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.1] text-surface-dark-foreground">
          Kleding bedrukken
          <br />
          in Den Haag
        </h1>
        <p className="text-lg md:text-xl text-surface-dark-foreground/80 max-w-lg">
          Bedrukken en borduren voor bedrijven, verenigingen en evenementen. Van T-shirts,
          hoodies en polo's tot complete bedrijfskleding — bedrukt vanaf 10 stuks.
        </p>
        <div className="flex flex-wrap gap-4 pt-2">
          <Button size="lg" asChild>
            <Link
              to="/offerte"
              onClick={() => trackEvent("cta_klik", { locatie: "hero", doel: "offerte" })}
            >
              Gratis offerte aanvragen <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="border-white/40 text-white bg-white/10 hover:bg-white/20" asChild>
            <a
              href="https://wa.me/31652526002"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent("whatsapp_klik", { locatie: "hero" })}
            >
              <MessageCircle className="mr-2 w-4 h-4" /> WhatsApp
            </a>
          </Button>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
